import Route from '@ember/routing/route';

export default class JoinMeeting extends Route {
  async model({ email, appointment, token }: { email: string; appointment: string; token: string }) {
    return {
      email,
      appointment,
      token,
    };
  }
}
